<template>
  <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item label="选择时间" prop="departureDate" label-width="110px">
        <el-date-picker v-model="departureDate" type="date" placeholder="请输入选择时间" value-format="yyyy-MM-dd" style="width:183px;"></el-date-picker>
      </el-form-item>
     <!-- <el-form-item label="线路" prop="busLinesId" label-width="60px">
        <el-select style="width: 100%;" v-model="busLinesId" filterable clearable placeholder="请选择线路">
          <el-option
            v-for="item in busLinesList"
            :key="item.Id"
            :value="item.Id"
            :label="item.LineChineseName"
          >
            <span style="float: left">{{ item.LineChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="司机" prop="driverId" label-width="60px">
       <el-select style="width: 100%;" v-model="driverId" filterable clearable placeholder="请选择司机">
          <el-option
            v-for="item in driverList"
            :key="item.Id"
            :value="item.Id"
            :label="item.Name"
          >
            <span style="float: left">{{ item.Name }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
      </el-form-item>      

       <!-- dxf 20220923 添加司机考勤统计类型 -->
      <el-form-item>
        <el-radio-group v-model="totaltype" @change="btnClick($event,'totaltype')" style="margin-right:12px;">
        <el-radio v-for="(radio, index) in totaltypeList" :key="index" :label="radio">{{radio}}</el-radio>
        </el-radio-group>
      </el-form-item>
      

    </el-form>
  </el-col>
</template>
<script>
//import { getBusLinesListPage, getDriverListPage } from "../../api/api";
import { getDriverListPage } from "../../api/api";

export default {
  name: "DriverMileageToolbar",
  data() {
    return { 
      totaltypeList: ["核定里程", "核定趟次"],
      driverList: [], //驾驶员列表  
      driverId:"", //驾驶员Id     
      totaltype: "核定里程",      
      departureDate: "" //选择时间
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      let itemExt = {};
      if(item !== null){
        itemExt = item;
      }

      itemExt.departureDate = this.departureDate;
      itemExt.totaltype = this.totaltype;
      itemExt.driverId = this.driverId;
      this.$emit("callFunction", itemExt); //将值传给父组件      
    },
   // setBusLinesId(busLinesId) {
   //   this.busLinesId = busLinesId;
  //  },
    setDepartureDate(departureDate) {
      this.departureDate = departureDate;
    },   

    
    btnClick(value,type){          
      this.totaltype = value;      
      this.callFunc(null);
    },
    
    //设置默认日期
    defaultDate(){
      let date = new Date();
      let year = date.getFullYear().toString();
      //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
      let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();
      //字符串拼接，开始时间，结束时间
      let departureDate = year + '-' + month + '-01';
      this.departureDate = departureDate; //将值设置给插件绑定的数据
    }
  },
  mounted() {
 //   getBusLinesListPage().then(res => {
  //    this.busLinesList = res.data.response.data;
 //     this.busLinesId = this.busLinesList.length > 0?this.busLinesList[0].Id:"";
 //   });

    let page = 1;
    let pageSize = 200;

    let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",        
        page: page,
        pageSize: pageSize
      };
    getDriverListPage(driverPara).then(res => {
       this.driverList = res.data.response.data;
  //     this.totaltype = '';
    });

    this.defaultDate();
  }
};
</script>